import { NoteBcbaV2, NoteRbtV2 } from 'src/app/core/models';
import {
  LocationApi,
  LocationInsurance,
} from '../location/models/locations.model';

export class ClientReportModel {
  pa_assessments: unknown[] = [];
  pa_assessmentsgroup: unknown[] = [];
  cpt: unknown;
  n_units: unknown;
  pa_number: unknown;
  insurances: unknown[] = [];
  insurance_id: unknown;
  insuranceiddd: unknown;
  insurer_name: unknown;
  sponsors: unknown[] = [];
  modifiers: unknown[] = [];
  noteRbt: unknown[] = [];
  pos_covered: unknown[] = [];
  pa_assessmentgroup: unknown[] = [];
  noteBcba: unknown[] = [];
  patient: unknown;
  patientID: unknown;
  patientName: unknown;
  doctor_selected_full_name: unknown;
  billing_total = 0;
  week_total_hours = '';
  week_total_units = 0;
  total_hours = 0;
  total_units = 0;
  charges = 0;
  unitPrize = 0;
  unitPrizeCpt = 0;
  xe = 0;
  is_xe = false;

  session_date: unknown;
  time_in: unknown;
  time_out: unknown;
  time_in2: unknown;
  time_out2: unknown;
  pos: unknown;
  billed = false;
  pay = false;
  billedbcba = false;
  paybcba = false;
  md: unknown;
  md2: unknown;
  mdbcba: unknown;
  md2bcba: unknown;
  pay_selected: unknown;
  billed_selected: unknown;
  total: unknown;
  totalPorPagar: unknown;
  resultconFactor: unknown;
  unidades: unknown;
  porPagar: unknown;
  horaTrabajada: unknown;
  factHoras: unknown;
  totalHoras: unknown;
  totalUnidades: unknown;
  units: unknown;
  hoursPerUnit: unknown;
  timePerUnit: unknown;

  tecnicoRbts: unknown;
  supervisor: unknown;
  npi: unknown;
  rbt_id: unknown;
  rbt2_id: unknown;
  bcba_id: unknown;
  bcba2_id: unknown;
  doctor_selected_bcba: unknown;
  full_name: unknown;
  doctors: unknown;
  tecnicoDoctorNames: unknown;
  patientId: unknown;
  services: unknown;
  provider: unknown;
  selectedCpt: unknown;
  //data: any;

  providersSponsorsList: unknown;
  factorPorcentual = 1.66666666666667;

  doctor_selected: unknown = null;
  combinedList: unknown[] = [];
  unitPrizeCptBcba: unknown;
  unitPrizeCptRbt: unknown;
  bcbaCptCode = '';
  rbtCptCode = '';
}

export interface ClientReportConfig {
  insurances: LocationInsurance[];
}

export interface ClientReportByLocation {
  noteRbts: NoteRbtV2[];
  noteBcbas: NoteBcbaV2[];
  location: LocationApi;
  totalPages: number;
  arrayPages: number[];
}
